<template>
	<modal-dialog :visible="visible" @close="close">
		<template v-slot:header>About Equivate</template>
		<template v-slot:body>
			<div>Version: {{version}}</div>
		</template>
	</modal-dialog>

</template>

<script type="text/javascript">

	import ModalDialog from "@/views/shared/ModalDialog";
	import { api } from "@/api/apiClient";

	export default {
		name: 'AboutModal',
		inheritAttrs: false,
		emits: ['close'],
		mixins: [],
		components: {
			ModalDialog
		},

		props: ['visible'],

		data() {
			return {
				version: '...'
			}
		},

		methods: {
			close() {
				this.$emit('close')
			}
    },

		created() {
			api.get('/api/build-info')
				.then(data => { this.version = data.version || 'unknown' })
				.catch(() => { this.version = 'unknown' })
		}
	}
</script>

<style lang="scss">
@import '../../styles/custom-variables';
</style>
